//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Motion/Motion.FlexCurveBuilder.js";
import "../Motion/Motion.SelectLink.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CurveParameterizedType",1,0],[1,"Curves",0,"SelectNXObjectList",0],[0,"CurvesOvrCtrl",1,0],[1,"FlexibleCurve",0,"Motion.FlexCurveBuilder",0],[1,"Link",0,"Motion.SelectLink",0],[0,"LinkOvrCtrl",1,0],[0,"Name",1,0],[0,"Point",1,"Point",0],[0,"PointOvrCtrl",1,0],[1,"SpacingExpression",0,"Expression",0],[0,"TypeOption",1,0]],[],[]];
SPLM.Motion.PointOnCurveBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.PointOnCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.PointOnCurveBuilder.Type = Object.freeze({
    "RigidCurve" : "RigidCurve", "FlexibleCurve" : "FlexibleCurve"});

export default SPLM;